module.exports = __webpack_public_path__ + "static/flags/BH-35f12b1bc2fd565801d32ef5f9697af6.gif";